import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Space } from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import { MdDelete, MdModeEditOutline } from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { ModalAddItemGroup } from '../../components/upeosoft/ModalApp/ModalApp';
import { deleteItemGroup, getItemGroup } from '../../network/ItemGroup';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';
import DashboardCards from '../Dashboard/DashboardCards';

const ItemGroup = ({ t }) => {
  const client = useQueryClient();
  const [editId, setEditId] = useState('');
  const [edit, setEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const { message } = App.useApp();
  const handleRemove = useMutation({
    mutationFn: (id) => deleteItemGroup(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getItemGroup] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getItemGroup],
    queryFn: () => getItemGroup(),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: t.edit + ' ' + t.itemGroup,
      icon: <MdModeEditOutline />,
      onClick: () => {
        setEditId(record?.name);
        setOpen(true);
        setEdit(true);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.Delete + ` (${record?.name})`}
          description={t.areYouSure}
          onConfirm={() => handleRemove.mutate(record?.name)}
          okText={t.yes}
          cancelText={t.no}
        >
          <span style={{ color: 'red' }}>
            {t.Delete} {t.itemGroup}
          </span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              setEditId(record?.name);
              setOpen(true);
              setEdit(true);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.parentItemGroup,
      dataIndex: 'parent_item_group',
    },
    {
      title: t.customItemGroupId,
      dataIndex: 'custom_item_group_id',
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            {/* <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditId(record?.name);
                setOpen(true);
                setEdit(true);
              }}
              icon={<MdModeEditOutline />}
            />
            <Popconfirm
              title={t.Delete + ` (${record?.name})`}
              description={t.areYouSure}
              onConfirm={() => handleRemove.mutate(record?.name)}
              okText={t.yes}
              cancelText={t.no}
            >
              <Button size="small" type="primary" danger icon={<MdDelete />} />
            </Popconfirm> */}
            <Dropdown
              menu={{ items: items(record) }}
              overlayClassName="custom-dropdown"
              trigger={['click']}
            >
              <Button
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Inventory} subTitle={t.itemGroup} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                setOpen(true);
                setEdit(false);
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.addItemGroup}
            </Button>
          }
        />
      </div>
      <ModalAddItemGroup
        open={open}
        setOpen={setOpen}
        edit={edit}
        setEditId={setEditId}
        editId={editId}
        t={t}
        setEdit={setEdit}
      />
    </div>
  );
};

export default ItemGroup;
